import React from "react";
import { formatDate } from "../utils/format";
const PostMeta = ({ date }) => (
  <small
    className="text-muted d-flex align-items-center gap-2"
    style={{ color: "#ffffff" }}
  >
    <i className="bi bi-clock" style={{ color: "#ffffff" }}></i>
    {formatDate(date)}
  </small>
);

export default PostMeta;
